<template>
  <default-view></default-view>
</template>
<script>
import DefaultView from "./Components/DefaultView";

export default {
  components: {
    DefaultView
  },
  mounted() {

    CmnMis.Frame.OnFrameInitComplete.Add(() => {
      CmnMis.Func.IsSysAdmin();
    }, "__FrameDefault__");

    let _isNotRecListViewState = (userForm) => {

      let _viewStateData = userForm.GetViewStateData();

      return _viewStateData && _viewStateData.ViewState && !(
        _viewStateData.ViewState == userForm.Cfg.ViewState.RecList 
        || _viewStateData.ViewState == userForm.Cfg.ViewState.List
      );
    }

    let _removeViewStateIfNotRecList = (userForm) => {

      let _viewStateData = userForm.GetViewStateData();

      //存在ViewState，且当前不是列表页需要删除显示状态参数
      if(_isNotRecListViewState(userForm)) {

        delete _viewStateData.ViewState;

        userForm.SetViewStateData(_viewStateData);
        userForm.SetUserFormInfoToUrl();
      }

    }

    CmnMis.Frame.AfterEverySave.Add(function (userForm, newRecID) {

      let _viewStateData = userForm.GetViewStateData();

      //存在返回表单代码
      if (userForm.IsExistViewStateData("ReturnUserFormID")) {

        //只有当显示模式为不是记录列表的时候才绑定保存按钮
        if (_isNotRecListViewState(userForm)) {
          //因为要直接返回，所以需要关闭继续增加功能
          userForm.IsUseContinueAdd = false;

          var _data = { data: {} };
          _data.data[userForm.KeyColName] = newRecID;

          CmnMis.Frame.ShowUserForm(_viewStateData.ReturnUserFormID, _data, _viewStateData.IsReloadWhenReturn);
          return false;
        }
      }
      else {

        _removeViewStateIfNotRecList(userForm);
      }

    }, "__FrameDefault__");

    CmnMis.Frame.OnEveryCancel.Add(function (userForm) {

      let _viewStateData = userForm.GetViewStateData();

      //存在返回表单代码
      if (userForm.IsExistViewStateData("ReturnUserFormID")) {

        //只有当显示模式为不是记录列表的时候才绑定取消按钮
        if(_isNotRecListViewState(userForm)) {

          CmnMis.Frame.ShowUserForm(_viewStateData.ReturnUserFormID, null, _viewStateData.IsReloadWhenReturn);
          return false;
        }
      }
      else {

        _removeViewStateIfNotRecList(userForm);
      }
      
    }, "__FrameDefault__");

    //框架初始化
    CmnMis.Frame.Init();
  },
};
</script>
